var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import arrow from '../../assets/images/navbar/arrow.svg';
import './Slides.scss';
var angles = {
    topLeftInit: 0,
    topLeftEnd: 0,
    topRightInit: 100,
    topRightEnd: 0,
    bottomRightInit: 95,
    bottomRightEnd: 100,
    bottomLeftInit: 0,
    bottomLeftEnd: 100,
};
var data = {
    slide: 1,
    eyebrowText: 'Our Ecosystem',
    headLineText: 'Wealth Management Technology',
    body: 'Envestnet’s software helps to streamline and automate the wealth management process so you spend less time on administrative tasks and more time on clients.',
    bulletList: [
        'Trading and reporting',
        'Client portal',
        'Client management (CRM)',
        'Portfolio management',
        'Tax management',
        'Advisor services',
    ],
    backgroudColor: '#005f9e',
    accoladesBanner: {
        secondaryImgSrc: '',
        secondaryImgAlt: '',
        SubHead: null,
        body: null,
    },
    id: 'wealth-management',
};
var defaultProps = { data: data };
export var ImageTextSlide = function (_a) {
    var className = _a.className, _b = _a.data, slide = _b.slide, eyebrowText = _b.eyebrowText, headLineText = _b.headLineText, body = _b.body, bulletList = _b.bulletList, backgroudColor = _b.backgroudColor, _c = _b.accoladesBanner, secondaryImgSrc = _c.secondaryImgSrc, secondaryImgAlt = _c.secondaryImgAlt, SubHead = _c.SubHead, bannerBody = _c.body, mainImgSrc = _b.mainImgSrc, mainImgSlide5 = _b.mainImgSlide5, mainImgSlide7 = _b.mainImgSlide7, mainImgAlt = _b.mainImgAlt, mobileImgSrc = _b.mobileImgSrc, mobileImgAlt = _b.mobileImgAlt, links = _b.links, id = _b.id, props = __rest(_a, ["className", "data"]);
    var accoladesBannerImageSizes = 'w-[101px] h-[42px] md:w-[134px] md:h-[56px] lg:w-[166px] lg:h-[69px] md:mr-[20px]';
    if (slide === 6) {
        accoladesBannerImageSizes =
            'w-[105px] h-[29px] md:w-[134px] md:h-[37px] lg:w-[170px] lg:h-[46px] md:mr-[21px]';
    }
    if (slide === 7) {
        accoladesBannerImageSizes =
            'w-[45px] h-[43px] md:w-[84px] md:h-[77px] lg:w-[127px] lg:h-[116px] md:mr-[70px]';
    }
    if (slide === 1) {
        className = 'wealthManagement';
    }
    if (slide === 7) {
        className = 'wealthSoluion';
    }
    if (slide === 6) {
        className = 'embedded';
    }
    var evenBullets = bulletList.filter(function (element, i) { return i % 2 === 0; });
    var oddBullets = bulletList.filter(function (element, i) { return i % 2 !== 0; });
    return (_jsxs("div", __assign({ id: id, className: "image-text-slide relative flex flex-col image-text-slide_flex-row  bg-white text-[#343741] " + (className || '') }, props, { children: [_jsxs("div", __assign({ className: "relative pt-[44px] md:pt-[63px] image-text-slide_inner" }, { children: [_jsx("div", __assign({ className: "border-b-[1px] border-solid border-[#343741] w-[157px] md:w-[176px] lg:w-[228px] pb-[14px] mb-[44px] md:mb-[56px] image-text-slide_inner-wrapper" }, { children: _jsx("p", __assign({ className: "text-[12px] leading-[1.67] text-right eyebrowText font-bold" }, { children: eyebrowText }), void 0) }), void 0),
                    _jsxs("div", __assign({ className: "box-content image-text-slide__content pl-[24px] pr-[24px] md:pl-[92px] md:pr-[92px] lg:pr-0" }, { children: [_jsx("h2", __assign({ className: "text-[32px] md:text-[36px] leading-[1.25] md:leading-[1.22] font-bold mb-[24px] md:mb-[32px]" }, { children: headLineText }), void 0),
                            _jsx("p", __assign({ className: "content-text text-[14px] md:text-[16px] leading-[1.71] md:leading-[1.5] mb-[24px] lg:mb-[32px]" }, { children: body }), void 0),
                            _jsx("ul", __assign({ className: "md:hidden" }, { children: bulletList.map(function (bulletCopy, i) { return (_jsxs("li", __assign({ className: "flex items-center mb-[20px]" }, { children: [_jsx("div", { className: "w-[9px] h-[9px] mr-[9px]", style: { backgroundColor: backgroudColor } }, void 0),
                                        _jsx("p", __assign({ className: "text-[14px] leading-[1.71]" }, { children: bulletCopy }), void 0)] }), "bullet-" + i)); }) }), void 0),
                            _jsxs("div", __assign({ className: "hidden md:flex" }, { children: [_jsx("ul", __assign({ className: "w-[246px] md:mr-[91px] lg:mr-[106px] list-wrapper" }, { children: evenBullets.map(function (bulletCopy, i) { return (_jsxs("li", __assign({ className: "flex items-center mb-[20px]" }, { children: [_jsx("div", { className: "w-[9px] h-[9px] mr-[9px]", style: { backgroundColor: backgroudColor } }, void 0),
                                                _jsx("p", __assign({ className: "text-[14px] leading-[1.71] list-element" }, { children: bulletCopy }), void 0)] }), "bullet-" + i)); }) }), void 0),
                                    _jsx("ul", { children: oddBullets.map(function (bulletCopy, i) { return (_jsxs("li", __assign({ className: "flex items-center mb-[20px]" }, { children: [_jsx("div", { className: "w-[9px] h-[9px] mr-[9px]", style: { backgroundColor: backgroudColor } }, void 0),
                                                _jsx("p", __assign({ className: "text-[14px] leading-[1.71] list-element" }, { children: bulletCopy }), void 0)] }), "bullet-" + i)); }) }, void 0)] }), void 0),
                            _jsx("ul", __assign({ className: "mt-[10px] mb-[24px] md:mb-[40px]" }, { children: links.map(function (_a, i) {
                                    var ctaCopy = _a.ctaCopy, ctaLink = _a.ctaLink, target = _a.target;
                                    return (_jsx("a", __assign({ href: ctaLink, rel: "noreferrer", target: target }, { children: _jsxs("p", __assign({ className: "cta-copy flex items-center text-[14px] leading-[1.71] font-bold text-[#005f9e] mb-[12px]" }, { children: [ctaCopy, _jsx("img", { className: "ml-[12px]", src: arrow, alt: "Arrow Icon" }, void 0)] }), void 0) }), "cta-" + i));
                                }) }), void 0)] }), void 0)] }), void 0),
            _jsx("div", __assign({ className: "image-text-slide__image-backdrop relative flex-shrink-0 w-screen max-w-full  md:h-[476px] lg:h-[797px] h-[334px] flex justify-center", style: { backgroundColor: backgroudColor } }, { children: _jsx("img", { className: "image-text-slide__image--mobile absolute max-w-full md:max-w-none md:max-h-full", src: mobileImgSrc, alt: mobileImgAlt }, void 0) }), void 0),
            _jsx("img", { className: "absolute right-0 top-1/2 max-w-none image-text-slide_bg-img", src: mainImgSrc, alt: mainImgAlt }, void 0),
            mainImgSlide5 && (_jsx("img", { className: "absolute right-0 top-1/2 max-w-none image-text-slide_bg-img mainImgSlide5", src: mainImgSlide5 }, void 0)),
            mainImgSlide7 && (_jsx("img", { className: "absolute right-0 top-1/2 max-w-none image-text-slide_bg-img mainImgSlide7", src: mainImgSlide7 }, void 0))] }), void 0));
};
ImageTextSlide.defaultProps = defaultProps;
